import {useState} from 'react';
import NotifyBackInStock from '../product/NotifyBackInStock.client';

function OnScreenModal({variantId, onClose}) {
  const handleContentClick = (event) => {
    event.stopPropagation();
  };
  return (
    <div className="on-screen-modal-backdrop" onClick={onClose}>
      <div className="on-screen-modal-content" onClick={handleContentClick}>
        <NotifyBackInStock variantId={variantId} onClose={onClose} />
      </div>
    </div>
  );
}

export default OnScreenModal;
